/**
 * Global constants for Apex Experience
 * Centralizes configuration values used across the application
 */

// Base URL for the application
// Used for: canonical URLs, sitemap, Open Graph, structured data
export const BASE_URL =
  process.env.NEXT_PUBLIC_BASE_URL || 'https://apexandes.com';

// Contact information
export const CONTACT = {
  whatsapp: '+56991998708',
  email: 'info@apexandes.com',
} as const;

// SEO defaults
export const SEO = {
  siteName: 'Apex Experience',
  defaultTitle: 'Apex Experience - Premier Adventure Travel & Luxury Lodges',
  defaultDescription: 'Apex sets a new standard in adventure travel. Unprecedented adventures at premier lodges & authentic connections at the heart of every trip.',
  locale: 'en_US',
  twitterHandle: '@apexexperience',
} as const;
